export const PROJECTS_PATH = '/jira/projects';
